import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { parseAgentFromPortal } from '../utils/parseAgentFromPortal'

export type AgentSessionTypes = [string, string, number, boolean] | null

type Store = {
    agentIdBySessionStorage: string | null
    setAgentBySessionStorage: (agentBySessionStorage: AgentSessionTypes) => void
    setAgentByResume: (agentBySessionStorage: string) => void

}

export const useAgent = create<Store>()(
    devtools(
        (set) => ({
            agentIdBySessionStorage: null,
            setAgentBySessionStorage: (agentBySessionStorage) =>
                set({
                    agentIdBySessionStorage: parseAgentFromPortal(agentBySessionStorage),
                }),
            setAgentByResume: (agentCode) =>
                set({
                    agentIdBySessionStorage: agentCode,
                }),
        }),
        { name: 'Agent' },
    ),
)
